import { Badge } from "@/components/ui/badge";

interface BadgesSectionProps {
  badges: string[];
}

export const BadgesSection = ({ badges }: BadgesSectionProps) => {
  if (!badges || badges.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-4">
      {badges.map((badge, index) => (
        <Badge 
          key={index} 
          variant="secondary"
          className="bg-secondary/10 text-secondary hover:bg-secondary/20 truncate max-w-[150px]"
        >
          {badge}
        </Badge>
      ))}
    </div>
  );
};